import React, { PropTypes } from 'react';

import Carousel from '../Carousel';
import EventCard from '../EventCard';

const EventListCarousel = ({
  events,
  source,
}) => (
  /**
   * Note: Inline styles to allow space for tooltip without
   * being cut off by overflow styles from within Slick slider
   */
  <div style={{ marginTop: '-20px' }}>
    {events.length > 0 &&
      <Carousel
        accessibility
        slidesToScroll={3}
        slidesToShow={3}
        swipeToSlide
        settingsSM={{
          slidesToScroll: 1,
          slidesToShow: 1,
          arrows: false,
          swipe: true,
          variableWidth: true,
        }}
        settingsMD={{
          slidesToScroll: 2,
          slidesToShow: 2,
          arrows: true,
        }}
      >
        {events.map(event => (
          <div key={event.id} style={{ height: '20rem', marginTop: '20px' }}>
            <EventCard
              {...event}
              source={source}
            />
          </div>))}
      </Carousel>}
  </div>
);

EventListCarousel.propTypes = {
  /**
   * Array of event data objects to render
   */
  events: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  /**
   * String source of list location.
   */
  source: PropTypes.string,
};

EventListCarousel.defaultProps = {
  loggedIn: false,
  onDone: () => {},
  onSave: () => {},
  onUnsave: () => {},
  savedEvents: undefined,
  source: undefined,
};

export default EventListCarousel;



// WEBPACK FOOTER //
// ./app/src/components/EventList/EventListCarousel.jsx